$(document).on('click', '.subpage-list .view-more-link', function(e) {
  e.preventDefault()
  fetch(window.location.href + e.target.href)
    .then(function(response) {
      if (response.ok) {
        return response.text()
      }
      return Promise.reject(response)
    })
    .then(function(html) {
      const div = document.createElement('div')
      div.innerHTML = html
      document.querySelector(
        '.subpage-list .view-more-link'
      ).outerHTML = div.querySelector('.articles').innerHTML
    })
    .catch(function(error) {
      console.warn(error)
    })
})
